/**
 * @generated SignedSource<<1b2470973d3312cddcb9a5763dbbf96c>>
 * @relayHash 1716f57cf42e2ced529fc33ecdd14534
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9fd7850fb2af841c7b2778ff02a681aa7e9300493fb5fde26a389fa80dff292

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_DesignPanelQuery } from './ui_DesignPanelQuery.graphql';

const node: PreloadableConcreteRequest<ui_DesignPanelQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c9fd7850fb2af841c7b2778ff02a681aa7e9300493fb5fde26a389fa80dff292",
    "metadata": {},
    "name": "ui_DesignPanelQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
